import React, { Component } from "react";
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'

const Styles = styled.div`
  .button {
    background-color: #000;
    margin: 3px
    border-color: #000
  }

  .card {

  }
`;

export default class AuthChoice extends Component {
    constructor(props) {
        super(props);


        this.state = {
            email: `${this.props.location.email}`,
            password: "",
            showAdd: false
        };
    }


    showAddPassword = () => {
        this.setState({ showAdd: !this.state.showAdd })
    }


    render() {
        const { data } = this.props.location

        return (
            <Styles>
                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label className="message">Get free tickets, live event updates, flash-sales and more with an account</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" />
                        <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
          </Form.Text>
                    </Form.Group>
                    <Form.Text className="text-muted">
                        Save your info for free tickets, faster purchases, and more!
          </Form.Text>

                    <Button variant="primary" type="submit" onPress={this.showAddPassword}>
                        Create Account
                    </Button>

                    <Link to={{
                        pathname: "/purchase",
                        data: data

                    }}>
                        <Button variant="primary" type="submit">
                            Guest
                    </Button>
                    </Link>

                </Form>
            </Styles>



        )
    }
}


